export const X_SMALL = 'X-Small', SMALL = 'Small', MEDIUM = 'Medium', LARGE = 'Large', X_LARGE = 'X-Large', XX_LARGE = 'XX-Large', XXX_LARGE = 'XXX-Large', SIZE_LIST = [X_SMALL, SMALL, MEDIUM, LARGE, X_LARGE, XX_LARGE, XXX_LARGE];
export const SLIM = 'Slim Fit', REGULAR = 'Regular Fit', RELAXED = 'Relaxed Fit', TALL_SLIM = 'Tall Slim Fit', TALL_REGULAR = 'Tall Regular Fit';
export const MANUAL_METHOD = 'manual', FIT_FINDER_METHOD = 'fitFinder', ASSOCIATE_METHOD = 'associate';
export const METHOD_MAP = new Map([
    [MANUAL_METHOD, 'Manual'],
    [FIT_FINDER_METHOD, 'Fit Finder'],
    [ASSOCIATE_METHOD, 'Store Associate']
]);
export const SIZE_TO_FIT = new Map([
    [X_SMALL, [SLIM]],
    [SMALL, [SLIM, REGULAR]],
    [MEDIUM, [SLIM, REGULAR, RELAXED, TALL_SLIM]],
    [LARGE, [SLIM, REGULAR, RELAXED, TALL_SLIM, TALL_REGULAR]],
    [X_LARGE, [SLIM, REGULAR, RELAXED, TALL_SLIM, TALL_REGULAR]],
    [XX_LARGE, [SLIM, REGULAR, RELAXED, TALL_SLIM, TALL_REGULAR]],
    [XXX_LARGE, [REGULAR, RELAXED, TALL_REGULAR]]
]);
export const FIT_FINDER_TO_SIZE = new Map([
    ['x-small', X_SMALL],
    ['small', SMALL],
    ['medium', MEDIUM],
    ['large', LARGE],
    ['x-large', X_LARGE],
    ['xx-large', XX_LARGE],
    ['xxx-large', XXX_LARGE]
]);
export const FIT_FINDER_TO_FIT = new Map([
    ['slim-fit', SLIM],
    ['regular-fit', REGULAR],
    ['relaxed-fit', RELAXED],
    ['tall-slim-fit', TALL_SLIM],
    ['tall-regular-fit', TALL_REGULAR]
]);
